var map = {
	"./backgrounds/initial.frag.glsl": 41,
	"./backgrounds/polka.frag.glsl": 42,
	"./building.frag.glsl": 43,
	"./fakeBox.frag.glsl": 44,
	"./overlays/opening_overlay.frag.glsl": 45,
	"./overlays/vignette.frag.glsl": 46,
	"./post/compose_replace.frag.glsl": 47,
	"./post/gaussian_horizontal.frag.glsl": 24,
	"./post/gaussian_vertical.frag.glsl": 25,
	"./post/glare_compose.frag.glsl": 26,
	"./post/glare_threshold.frag.glsl": 23,
	"./post/glare_threshold_downsample.frag.glsl": 22,
	"./post/glitch.frag.glsl": 31,
	"./post/sobel_horizontal.frag.glsl": 28,
	"./post/sobel_vertical.frag.glsl": 29
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;



//////////////////
// WEBPACK FOOTER
// ./src/shaders ^\.\/.*\.frag\.glsl$
// module id = 40
// module chunks = 0